import firebase from "../firebase";

const earnings = firebase.ref("/earnings");
const partners = firebase.ref("/partners");
const clients = firebase.ref("/clients");

class EarningService {
    getAll(userInfo) {        
        if(userInfo.Role === 'Partner Admin' || userInfo.Role === 'Partner Staff'){
            return earnings.orderByChild("PartnerId").equalTo(userInfo['Company']);
          } else {
            return earnings;
          }
    } 
    
    updateStatus(key,statusVal) {
        return earnings.child(key).update({
            IsHidden: statusVal,
        });
    }

    getPartnerName(id){
        return partners.orderByChild("Id").equalTo(id)
    }
}

export default new EarningService();
